import { render } from "./Header.vue?vue&type=template&id=c7ef42b6&scoped=true&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=c7ef42b6&scoped=true&lang=css"

import exportComponent from "/workspaces/theokoel.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7ef42b6"]])

export default __exports__